export default "__VITE_ASSET__Xj5sPFOn__"